import React, { useEffect, useState } from 'react';
import { FiSmartphone, FiMonitor, FiTablet, FiLoader, FiRefreshCw, FiX } from 'react-icons/fi';
import Modal from 'components/basicos/Modal';
import { useDeviceBridge } from 'shared/deviceBridge';

const ICONOS = { movil: FiSmartphone, tablet: FiTablet, pc: FiMonitor };

const S = {
  lista: { display: 'flex', flexDirection: 'column', gap: '10px' },
  dispositivo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1px solid var(--agx-border)',
    background: 'var(--agx-bg)',
    cursor: 'pointer',
    transition: 'all 0.15s',
    textAlign: 'left',
    width: '100%',
    fontFamily: 'inherit',
  },
  nombre: { fontWeight: 600, fontSize: '14px', color: 'var(--agx-text)' },
  sub: { fontSize: '12px', color: 'var(--agx-muted)' },
  estado: (online) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: online ? '#16a34a' : '#9ca3af',
    flexShrink: 0,
  }),
  vacio: { textAlign: 'center', color: 'var(--agx-muted)', padding: '24px 0', fontSize: '14px' },
  progreso: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', padding: '28px 0' },
  error: {
    background: '#fef2f2',
    color: '#dc2626',
    padding: '12px 16px',
    borderRadius: '12px',
    fontSize: '13px',
    marginBottom: '12px',
  },
  acciones: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '16px' },
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '9px 16px',
    borderRadius: '10px',
    border: 'none',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};

export default function BridgeRequestModal({ open, onClose, tipo, titulo, params = {}, onResultado }) {
  const { dispositivos, listarDispositivos, solicitar } = useDeviceBridge();
  const [enviandoA, setEnviandoA] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setEnviandoA(null);
      setError(null);
      listarDispositivos();
    }
  }, [open, listarDispositivos]);

  const enviar = async (device) => {
    setError(null);
    setEnviandoA(device);
    try {
      const res = await solicitar(device.device_id, tipo, params);
      if (onResultado) onResultado(res);
      onClose();
    } catch (e) {
      const msg = e?.message || 'No se pudo contactar el dispositivo';
      setError(msg === 'peticion_expirada' ? 'El dispositivo no respondió a tiempo.' : msg);
      setEnviandoA(null);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={titulo || 'Elegir dispositivo'} width="sm">
      {error && <div style={S.error}>{error}</div>}

      {enviandoA ? (
        <div style={S.progreso}>
          <FiLoader size={32} style={{ animation: 'spin 1s linear infinite', color: 'var(--agx-muted)' }} />
          <div style={S.nombre}>Esperando respuesta en {enviandoA.nombre}…</div>
          <div style={S.sub}>Abre la notificación en ese dispositivo.</div>
        </div>
      ) : (
        <>
          <div style={S.lista}>
            {dispositivos.length === 0 ? (
              <div style={S.vacio}>
                No hay otros dispositivos con tu sesión iniciada.
                <br />
                Inicia sesión en el celular con el mismo usuario.
              </div>
            ) : (
              dispositivos.map((d) => {
                const Icono = ICONOS[d.tipo] || FiSmartphone;
                return (
                  <button key={d.device_id} style={S.dispositivo} onClick={() => enviar(d)}>
                    <Icono size={20} style={{ color: 'var(--agx-text)', flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                      <div style={S.nombre}>{d.nombre}</div>
                      <div style={S.sub}>{d.online ? 'Conectado' : 'Fuera de línea · se enviará notificación'}</div>
                    </div>
                    <span style={S.estado(d.online)} />
                  </button>
                );
              })
            )}
          </div>

          <div style={S.acciones}>
            <button
              style={{ ...S.btn, background: 'transparent', color: 'var(--agx-muted)' }}
              onClick={() => listarDispositivos()}
            >
              <FiRefreshCw size={14} /> Actualizar
            </button>
            <button
              style={{ ...S.btn, background: '#f1f5f9', color: '#475569' }}
              onClick={onClose}
            >
              <FiX size={14} /> Cancelar
            </button>
          </div>
        </>
      )}
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Modal>
  );
}
